export default __webpack_public_path__ + "static/media/home-decor-img-09.7b067717.png";